import { Link } from "react-router-dom"

const Pagination = ({
    pagination = {
        total: 0,
        per_page: 0,
        current_page: 0,
        from: 0,
        to: 0
    },
    onNextPage = () => {},
    onPreviousPage = () => {},
    onPage = () => {},
    dense = false
}) => {
    const totalPages = Math.ceil(pagination.total / pagination.per_page);
    const currentPage = pagination.current_page;
    const isFirstPage = currentPage <= 1;
    const isLastPage = currentPage >= totalPages;

    // Apply dense mode dimensions
    const itemSize = dense ? 'w-40 h-40' : 'w-64 h-64';
    const gapSize = dense ? 'gap-8' : 'gap-16';
    const fontSize = dense ? 'text-sm' : 'text-md';
    const arrowSize = dense ? 'text-xl' : 'text-xxl';

    const getPageNumbers = () => {
        const pages = [];
        const maxVisiblePages = 5;
        const halfVisible = Math.floor(maxVisiblePages / 2);

        let startPage = Math.max(1, currentPage - halfVisible);
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        // Add first page
        if (startPage > 1) {
            pages.push(1);
            if (startPage > 2) pages.push('...');
        }

        // Add middle pages
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        // Add last page
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) pages.push('...');
            pages.push(totalPages);
        }

        return pages;
    };

    return (
        <ul className={`flex-wrap ${gapSize} pagination flex-center`}>
            <li className="page-item">
                <div
                    className={`${itemSize} border border-gray-100 page-link flex-center ${arrowSize} rounded-8 fw-medium text-neutral-600 ${isFirstPage ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                    onClick={() => !isFirstPage && onPreviousPage()}
                    disabled={isFirstPage}
                >
                    <i className="ph-bold ph-arrow-left" />
                </div>
            </li>

            {getPageNumbers().map((pageNum, index) => (
                <li key={index} className={`page-item ${pageNum === currentPage ? 'active' : ''}`}>
                    {pageNum === '...' ? (
                        <div className={`${itemSize} flex-center ${fontSize} fw-medium text-neutral-600`}>
                            {pageNum}
                        </div>
                    ) : (
                        <div
                            className={`${itemSize} border border-gray-100 cursor-pointer page-link flex-center ${fontSize} rounded-8 fw-medium text-neutral-600`}
                            onClick={() => onPage(pageNum)}
                        >
                            {dense ? pageNum : String(pageNum).padStart(2, '0')}
                        </div>
                    )}
                </li>
            ))}

            <li className="page-item">
                <div
                    className={`${itemSize} border border-gray-100 page-link flex-center ${arrowSize} rounded-8 fw-medium text-neutral-600 ${isLastPage ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                    onClick={() => !isLastPage && onNextPage()}
                    disabled={isLastPage}
                >
                    <i className="ph-bold ph-arrow-right" />
                </div>
            </li>
        </ul>
    )
}

export default Pagination